import { isObjectLike } from 'lodash';

export default {
  validate: (value, { items, required = true }) => {
    let itemsArray;
    if (Array.isArray(items)) itemsArray = items.slice();
    else if (typeof items === 'string') itemsArray = items.split(',');
    else if (isObjectLike(items)) itemsArray = Object.keys(items);
    else itemsArray = [];
    itemsArray = itemsArray.map(item => item.toString());
    return {
      valid: required ? itemsArray.includes(([undefined, null].includes(value) ? '' : value).toString()) : true,
      required,
    };
  },
  params: ['items', 'required'],
  computesRequired: true,
};
